<div class="flex items-start justify-between gap-md">
  <div class="flex flex-col gap-2xs">
    <h3 class="reset-h text-base font-semibold text-default">{{ 'Missing a field?' | translate }}</h3>
    <p class="reset-p text-base text-support">{{ 'Add it to your contract and upload it again.' | translate }}</p>
  </div>

  <button
    sb-button
    color="primaryTransparent"
    size="sm"
    class="shrink-0"
    aria-controls="missing-field-steps"
    [attr.aria-expanded]="isOpen()"
    (click)="isOpen.set(!isOpen())"
  >
    @if (isOpen()) {
      {{ 'Hide how' | translate }}
    } @else {
      {{ 'Show how' | translate }}
    }
  </button>
</div>

@if (isOpen()) {
  <div id="missing-field-steps" class="flex flex-col gap-md">
    <ol class="reset-ul flex flex-col gap-sm text-base text-support">
      <li class="flex gap-md">
        <span class="w-md shrink-0 font-medium text-default">1.</span>
        {{ 'Open your contract.' | translate }}
      </li>
      <li class="flex gap-md">
        <span class="w-md shrink-0 font-medium text-default">2.</span>
        <div class="flex min-w-0 flex-1 flex-col gap-sm">
          {{ 'Type the field name in curly brackets where it goes, like:' | translate }}
          <div
            class="flex items-center justify-between gap-md rounded-sm border border-solid border-default bg-surface px-md py-xs"
          >
            <span class="text-sm text-default">{{ '{' + exampleVariable + '}' }}</span>
            <button
              sb-button
              color="primaryTransparent"
              size="sm"
              [attr.aria-label]="'Copy [variable]' | translate: { variable: '{' + exampleVariable + '}' }"
              (click)="copy()"
            >
              <sb-icon name="copy-2-regular" />
              {{ 'Copy' | translate }}
            </button>
          </div>
        </div>
      </li>
      <li class="flex gap-md">
        <span class="w-md shrink-0 font-medium text-default">3.</span>
        {{ 'Save it as a .docx file, then upload it here.' | translate }}
      </li>
    </ol>

    <div class="flex">
      <button sb-button color="secondary" (click)="uploadAgain.emit()">
        <sb-icon name="upload-3-regular" />
        {{ 'Upload again' | translate }}
      </button>
    </div>
  </div>
}
